module.exports = __webpack_public_path__ + "static/media/absence.ba1f35d8.svg";